import { isKik } from "../../utils/platform";
import { closeWebviewFb } from "../../utils/facebookWebview";
import { closeWebviewKik } from "../../utils/kikWebview";

export default () => () => {
  if (isKik()) {
    return closeWebviewKik();
  } else {
    return closeWebviewFb();
  }
};



// WEBPACK FOOTER //
// ./src/store/epics/closeWebview.js